
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"96","height":"99"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 11127","transform":"translate(-914 -141)","fill":"#28a745"}},[_c('g',{attrs:{"transform":"translate(913 140)"}},[_c('path',{attrs:{"data-name":"Path 9972","d":"M64.97 32.162L40.85 56.131 29.913 45.194a3.072 3.072 0 10-4.343 4.345l13.182 13.183a3.049 3.049 0 002.247.9 3.3 3.3 0 002.247-.9l26.217-26.217a3.074 3.074 0 000-4.345 3.258 3.258 0 00-4.493.002z"}}),_c('path',{attrs:{"data-name":"Path 9973","d":"M89.239 35.007a2.871 2.871 0 00-2.247 3.6 43.152 43.152 0 01.9 8.839A40.449 40.449 0 1147.441 6.992a39.443 39.443 0 0117.079 3.746 3.05 3.05 0 102.547-5.543A48.578 48.578 0 0047.441 1a46.034 46.034 0 1045.393 36.254 3.179 3.179 0 00-3.595-2.247z"}}),_c('circle',{attrs:{"data-name":"Ellipse 53","cx":"2.996","cy":"2.996","r":"2.996","transform":"translate(78.153 17.329)"}})]),_c('circle',{attrs:{"data-name":"Ellipse 54","cx":"47","cy":"47","r":"47","transform":"translate(916 146)","opacity":".038"}})])])
          )
        }
      }
    